import { lazy } from 'react';

// Personas (Virtual AI Team Members)
export const PersonaList = lazy(() =>
  import('@/capabilities/automation-personas/pages/PersonaList').then((m) => ({ default: m.PersonaList }))
);

export const PersonaEditor = lazy(() =>
  import('@/capabilities/automation-personas/pages/PersonaEditor').then((m) => ({ default: m.PersonaEditor }))
);

export const PersonaActionQueue = lazy(() =>
  import('@/capabilities/automation-personas/pages/PersonaActionQueue').then((m) => ({ default: m.PersonaActionQueue }))
);

export const PersonaActivityLog = lazy(() =>
  import('@/capabilities/automation-personas/pages/PersonaActivityLog').then((m) => ({ default: m.PersonaActivityLog }))
);
